<template>
  <div class="index" v-loading="loading">
    <div class="index-con">
      <div class="login-con">
        <div class="index-title">Create an account</div>
        <div class="login-cons">
          <div class="login-center">
            <div class="login-text" style="margin-bottom: 30px">
              Already have an account?
              <span class="text-blue cup" @click="toLogin">Please login</span>
            </div>
            <div class="login-list">
              <p class="login-title">Email*</p>
              <el-input type="text" v-model="email" placeholder="Email"></el-input>
            </div>
            <div class="login-list df">
              <p class="login-title">Title*</p>
              <el-radio-group v-model="mytitle">
                <el-radio :label="'Prof.'">Prof.</el-radio>
                <el-radio :label="'Dr.'">Dr.</el-radio>
                <el-radio :label="'Mr.'">Mr.</el-radio>
                <el-radio :label="'Mrs.'">Mrs.</el-radio>
                <el-radio :label="'Ms.'">Ms.</el-radio>
              </el-radio-group>
            </div>
            <div class="login-list">
              <p class="login-title">First name*</p>
              <el-input type="text" v-model="firstname" placeholder="First name"></el-input>
            </div>
            <div class="login-list">
              <p class="login-title">Last name*</p>
              <el-input type="text" v-model="lastname" placeholder="Last name"></el-input>
            </div>
            <div class="login-list">
              <p class="login-title">Password*</p>
              <el-input type="password" v-model="password"
                placeholder="The password length needs to be 6-15"></el-input>
            </div>
            <div class="login-list">
              <p class="login-title">Retype Password*</p>
              <el-input type="password" v-model="twoPsd"></el-input>
            </div>
            <!-- <div class="login-list">
              <p class="login-title">Name*</p>
              <el-input type="text" v-model="name" />
            </div> -->
            <div class="login-list">
              <p class="login-title">Country*</p>
              <el-select class="el-country-select" style="width: 100%" v-model="country" placeholder="Country"
                @change="changeCountry">
                <el-option v-for="itm in countryList" :key="itm.country_id" :label="itm.nicename"
                  :value="itm.country_id">
                </el-option>
              </el-select>
              <!-- <el-input type="text" v-model="country" /> -->
            </div>
            <div class="login-list">
              <p class="login-title">Affiliation*</p>
              <el-input type="text" v-model="affiliation" placeholder="Affiliation"></el-input>
            </div>
            <div class="login-list">
              <p class="login-title">Address*</p>
              <el-input type="text" v-model="address" placeholder="Address"></el-input>
            </div>
            <div class="login-list">
              <p class="login-title">Cellphone*</p>
              <div class="d-f">
                <el-select class="el-country-select" style="max-width: 300px" v-model="phoneCode"
                  placeholder="Country Code">
                  <el-option v-for="itm in countryList" :key="itm.phonecode"
                    :label="itm.nicename + ': ' + itm.phonecode + '+'" :value="itm.phonecode">
                  </el-option>
                </el-select>

                <el-input style="flex: 1" placeholder="Cellphone" type="text" v-model="tel"></el-input>
              </div>
            </div>
            <!-- <div class="login-list">
              <p class="login-title">About*</p>
              <textarea
                placeholder="Special instructions"
                v-model="about"
                cols="90"
                rows="4"
                maxlength="1000000"
              ></textarea>
            </div> -->

            <div class="login-list">
              <p class="login-title">Verification Code* (Case sensitive)</p>
              <div class="d-flex">
                <el-input type="text" v-model="code" placeholder="Verification Code"></el-input>
                <ValidCode @input="createValidCode" />
              </div>
            </div>
            <div class="login-btn" @click="regFn">Sign in</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ValidCode from "./code.vue";

export default {
  components: {
    ValidCode,
  },
  data() {
    return {
      loading: false,
      validCode: "",
      radio: 3,
      email: "", // "282@qq.com",
      mytitle: "Dr.", // "Dr.",
      firstname: "", // "aaa",
      lastname: "", // "bbb",
      password: "", // "cccddd",
      twoPsd: "", // "cccddd",
      code: "", // "1234",
      myCode: "", // "1234",

      name: "", // "aaa",
      country: "", // "bbb",
      affiliation: "", // "cccddd",
      address: "", // "cccddd",
      fax: "", // "1234",
      about: "", // "1234",
      countryList: [],
      tel: "",

      phoneCode: "",
    };
  },
  mounted() {
    this.getCountryListFn();
  },
  methods: {
    changeCountry() {
      this.countryList.filter((item) => {
        if (item.country_id == this.country) {
          this.phoneCode = item.phonecode;
        }
      });
    },
    getCountryListFn() {
      this.loading = true;
      this.$http.country_list().then((res) => {
        this.loading = false
        this.countryList = res.data;
      });
    },
    createValidCode(data) {
      this.validCode = data;
      console.log(this.validCode, "-=-=-=");
    },
    toLogin() {
      this.$router.push("/login");
    },
    regFn() {
      console.log(
        this.code.toLowerCase(),
        this.validCode.toLowerCase(),
        this.code.toLowerCase() != this.validCode.toLowerCase()
      );
      if (!this.email) {
        this.$message.error("Please enter your email");
        return;
      }
      if (!this.firstname) {
        this.$message.error("Please enter your Firstname");
        return;
      }
      if (!this.lastname) {
        this.$message.error("Please enter your Lastname");
        return;
      }
      if (!this.password) {
        this.$message.error("Please enter your Password");
        return;
      }
      if (!this.twoPsd) {
        this.$message.error("Please enter your Retype Password");
        return;
      }
      if (this.twoPsd != this.password) {
        this.$message.error("Password inconsistency");
        return;
      }
      if (this.password.length < 6 || this.password.length > 15) {
        this.$message.error("The password length needs to be 6-15");
        return;
      }
      if (!this.country) {
        this.$message.error("Please enter your country");
        return;
      }
      if (!this.affiliation) {
        this.$message.error("Please enter your affiliation");
        return;
      }
      if (!this.address) {
        this.$message.error("Please enter your address");
        return;
      }
      if (!this.tel) {
        this.$message.error("Please enter your Cellphone");
        return;
      }
      if (!this.code) {
        this.$message.error("Please enter Verfication Code");
        return;
      }
      if (this.code.toLowerCase() != this.validCode.toLowerCase()) {
        this.$message.error("Verfication Code inconsistency");
        return;
      }
      var params = {
        Firstname: this.firstname,
        email: this.email,
        Lastname: this.lastname,
        password: this.password,
        mytitle: this.mytitle,
        ifcn: 0,
        name: this.name,
        country: this.country,
        affiliation: this.affiliation,
        address: this.address,
        fax: this.fax,
        tel: this.tel,
        phoneCode: this.phoneCode,
        about: this.about,
      };
      var that = this;
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$http.register(params).then((res) => {
        console.log(res);
        loading.close();
        if (res.code == "200") {
          that.$message.success("Registration successful");
          var con = res.data[0];
          localStorage.setItem("Firstname", con.Firstname);
          localStorage.setItem("Lastname", con.Lastname);
          localStorage.setItem("email", con.email);
          localStorage.setItem("mytitle", con.mytitle);
          localStorage.setItem("token", con.token);
          localStorage.setItem("visitor_id", con.visitor_id);
          localStorage.setItem("ifcn", 0);
          setTimeout(() => {
            that.$router.push("/loginThen");
          }, 500);
        } else {
          that.$message.error(res.msg);
        }
      });
    },
  },
};
</script>
<style scoped>
.index-con {
  width: 1200px;
  margin: 0 auto;
}

.login-con {
  margin-top: 20px;
}

.index-title {
  font-size: 18px;
  font-weight: 500;
  height: 60px;
  line-height: 60px;
  padding-left: 20px;
  box-sizing: border-box;
  background: #f5f5f5;
  border-bottom: 1px solid #ddd;
}

.login-con {
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-bottom: 30px;
}

.login-cons {
  padding: 90px 20px 20px;
  box-sizing: border-box;
}

.df {
  display: flex;
  align-items: center;
}

.df .login-title {
  margin-right: 20px;
}

.d-f {
  display: flex;
}

.login-center {
  width: 70%;
  margin: 0 auto;
}

.login-title {
  font-weight: 600;
  margin-bottom: 10px;
}

.login-list {
  margin-bottom: 20px;
}

.login-list input {
  width: 100%;
  padding-left: 10px;
  box-sizing: border-box;
  color: #555;
  height: 42px;
  border-radius: 4px;
  border: 1px solid #ccc;
}

.d-flex {
  display: flex;
}

.d-flex input {
  flex: 1;
  width: auto;
  margin-right: 20px;
}

.login-btn {
  color: #fff;
  background-color: #428bca;
  border: 1px solid #357ebd;
  border-radius: 4px;
  padding: 6px 12px;
  cursor: pointer;
  font-size: 16px;
  margin-bottom: 15px;
  display: inline-block;
}

.login-text {
  margin-bottom: 15px;
}

.text-blue {
  color: #28d6ec;
  cursor: pointer;
}

@media screen and (max-width: 768px) {
  .index-con {
    width: 100%;
  }

  .login-tip {
    font-size: 14px;
    text-indent: 10px;
  }

  .d-f {
    display: block;
  }

  .login-list input {
    width: 100%;
  }

  .info-small-title {
    height: auto;
  }

  .login-center {
    width: 100%;
  }

  .el-country-select {
    width: 100% !important;
    margin-bottom: 20px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/register.vue